import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { currencyConfig, DEFAULT_CURRENCY } from "@/config/currency.config";
import { CurrencyValue } from "@/constants/propertyConstants";
import { ICurrencyValue } from "@/types/currency.types";
import { ConvertedPrices } from "@/types/pricing.types";

interface ICurrencyStore {
  currency: ICurrencyValue;
  currencyList: ICurrencyValue[];
  setCurrency: (val: string) => void;

  // Helpers for multi-currency system
  getConvertedPrice: (
    convertedPrices: ConvertedPrices | undefined,
    currency: CurrencyValue,
  ) => number | undefined;
  formatCurrencySymbol: (currency: CurrencyValue) => string;
}

const initialValue = currencyConfig.get(DEFAULT_CURRENCY);

export const useCurrencyStore = create<ICurrencyStore>()(
  devtools(
    persist(
      (set) => ({
        currency: { ...initialValue! },
        currencyList: [...currencyConfig.values()],
        setCurrency: (val) => set({ currency: currencyConfig.get(val) }),

        // Helper to get converted price for specific currency
        getConvertedPrice: (convertedPrices, currency) => {
          if (!convertedPrices) {
            return undefined;
          }
          return convertedPrices[currency];
        },

        // Helper to get currency symbol
        formatCurrencySymbol: (currency) => {
          const config = currencyConfig.get(currency);
          return config?.symbol || "$";
        },
      }),
      {
        name: "currency-storage",
        partialize: (state) => ({ currency: state.currency }),
      },
    ),
  ),
);
